import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    totalStrategies: { default: 14 },
    visibleCount: { default: 5 },
    hiddenCount: { default: 1 },
    coverageGroups: { default: 5 }
  },
  setup(__props: any) {

const { t } = useI18n()
const props = __props

const statisticsItems = computed(() => [
  { label: t('screenWatermark.totalStrategies'), value: props.totalStrategies, span: 8 },
  { label: t('screenWatermark.visibleHidden'), value: `${props.visibleCount}/${props.hiddenCount}`, span: 8 },
  { label: t('screenWatermark.coverageGroups'), value: props.coverageGroups, span: 8 }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})